import './axios';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import './plugins';
import store from './store';
import {sync} from 'vuex-router-sync';
import VueTheMask from 'vue-the-mask';
import Vue2Editor from 'vue2-editor';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';

Vue.use(Chartkick.use(Chart))
Vue.config.productionTip = false
Vue.use(VueTheMask);
// @ts-ignore
Vue.use(Vue2Editor);

sync(store, router)

new Vue({
    router,
    // @ts-ignore
    vuetify,
    store,
    render: h => h(App),
}).$mount('#app')
